export const except = <T>(values: T[], exclude: T[], comparer = (a: T, b: T)  => a === b) => {
  return values.filter(value => exclude.findIndex(e => comparer(value, e)) === -1);
}

export const intersect = <T>(first: T[], second: T[], comparer = (a: T, b: T) => a === b) => {
  return first.filter(f => second.findIndex(s => comparer(f, s)) !== -1);
}
